css .meta
	fs:sm/1.2 c:gray6 fw:400

css .alert
	p:4 px:4 c:gray6 bg:gray1 fs:sm ta:center fl:0 0 auto
	&.yellow bg:yellow2 c:yellow8

css .tabs
	d:hflex ja:center rdt:inherit us:none
	fs:sm-/1.2 fw:500 tt:uppercase
	bdb:1px solid gray3 mx:3

css .tool
	all:unset d:flex ja:center
	w:6 h:6 rd:sm
	c:gray6 @hover:blue5 # .checked:blue6
	svg w:4 h:4 va:top
	&.red c:red5 @hover:red6
	&.green c:green5 @hover:green6
	
	# Larger hit area on small screens
	@!700 @before pos:absolute content:" " inset:0 m:-3

css .tab all:unset
	bdt:1px solid clear
	bdb:1px solid clear
	d:hflex h:6 ja:center mx:1 px:1px mb:-1px
	pe.checked:none
	# c:blue6 @hover:blue5 .checked:gray8
	c:gray6 @hover:blue6 .checked:blue7
	bcb:clear @hover:currentColor .checked:currentColor
	
css .stats c:gray6 fs:xs/1.4 fw:500 d:hflex ai:center
	.stat .link c:blue7 td:none @hover:underline
	.stat + .stat @before content:"|" o:0.4 mx:1ex

css .md
	fs:sm/1.3 c:gray8
	>>> a c:blue6 @hover:blue7
	>>> h1 fs:md/1 fw:600 mt:2 bdb:1px solid gray3
	>>> h2 fs:md-/1 fw:600 mt:4 my:2 py:1 bdb:1px solid gray3
	>>> h3 fs:sm/1.2 fw:600 my:2
	>>> p my:2
	>>> code
		fs:xs ff:mono c:gray7 bg:gray1
	>>> li pb:1 fs:sm/1.1
	>>> ul my:2 pl:4 list-style:none
		li @before
			content:"\2022" c:gray6 ml:-4 d:inline-block w:4 fw:600 ta:center
	>>> ol
		counter-reset:ol-counter
		list-style:none pl:4 my:2
		li counter-increment:ol-counter
			@before content:counter(ol-counter) ". " c:gray6 ml:-4 d:inline-block w:4 ta:left

tag pane-section
	key = 'scrimInfoPane'
	name = 'section'

	css
		pos:absolute inset:0
		d:none .active:vflex

	css .meta
		fs:sm/1.2 c:gray6 fw:400

	css .stats c:gray6 fs:xs/1.4 fw:500 d:hflex ai:center
		.stat .link c:blue7 td:none @hover:underline
		.stat + .stat @before content:"|" o:0.4 mx:1ex
		@!600 flw:wrap

	def commit
		if active =? (settings[key] == name)
			flags.toggle('active',!!active)
		super if active


tag scrim-next-up
	css
		d:block p:3 px:5 bg:white j:center td:none c:inherit
		td:none c:inherit rdb:md bg:blue2 pos:relative

		@before content: " " d:block rd:inherit t:0 l:0 h:100%
			tween: sizes 0.2s quart-in-out
			pos:absolute
			w: 0 bg:blue4/30
		
		.close w:4 h:4 pe:none o:0 ml:-4 mr:0 tween: sizes 0.3s ease-in-out c:red6
		# pos:absolute t:3 r:5
		.title @before content: "Next " c:blue7 fw:600

		&.queued
			@before w:100% tween: sizes 4.9s linear
			.close pe:auto ml:0 mr:1 o:1

	get item do data

	course = null

	def queueNext
		timeout = setTimeout(&,5000) do
			document.location.href = data.contextualUrl(course)
		flags.add('queued')
		return cancelNext.bind(self)
	
	def cancelNext
		clearTimeout(timeout)
		timeout = null
		flags.remove('queued')
		emit('cancel')

	def render
		<self @click.stop> <a$next[td:none c:inherit d:hflex fs:sm/1.7 a:center].row data-id=data.id href=data.contextualUrl(course)>
			<svg src="svg/x.svg" .close @click.stop.prevent=cancelNext>
			<span.title.truncate[fl:1]> "{data.title}"
			<span.meta.prog[ta:right c:gray6 fs:xs]> (data.duration or 0).format!

tag scrim-queue

	css
		ofy:auto fl:1 d:block pb:4 cursor:default
		overscroll-behavior-y:none
		1item:28px
	
	css a td:none c:inherit
	
	css .row h:28px
	css .head pos:sticky t:0 bg:white/85 zi:2
		d:hflex fs:xs fw:600 a:center px:3

	css .mod-head h:7 pt:3 fs:sm fw:600 c:blue7
	css .list-head t:6 zi:1 fs:md

	css .scrim px:2 fs:md-/1.4 d:hflex a:center bg:white mx:3
		@hover bg:gray1 c:blue8 rd:sm
		.title fl:1
			@after content: $status fs:sm fw:500 px:1 o:0.7
		.meta c:gray6 fs:xs

		&.current c:white bg:blue5 rd:sm @hover:blue6
			.meta c:white
	
	css .mod.collapsed
		> .head fw:500 c:gray6 @hover:blue7
		> .children d:none
	
	css .list.collapsedz
		> .children d:none

	def expand e
		if let list = e.target.closest('.collapsed')
			list.classList.remove('collapsed')

	def render
		# only render once for performance
		return if rendered?
		let course = data.course or {}
		let modules = course.modules or [course]
		let pl = data.playlist

		# if !data.course and data.playlist
		#	modules = [{playlists: [data.playlist]}]

		unless data.current?
			for mod in modules
				for pl in mod.playlists
					for scrim in pl.items
						if scrim == data
							scrim.current? = yes
							mod.current? = yes
							pl.current? = yes

		<self>
			if data.course
				<div> for mod in modules
					<.mod .collapsed=!mod.current?>
						<.head.mod-head.row [d:none]=(!mod.id) @click=expand> mod.name or mod.title or ''
						<.children> for pl in mod.playlists
							<.list .collapsed=!pl.current?>
								<.head.list-head.row> pl.title
								<.children[$count:{pl.items.length}]> for item,i in pl.items
									<a.scrim.row .current=(item == data) data-id=item.id href=item.contextualUrl(course)>
										<span.title.truncate> "{i + 1}. {item.title}"
										<span.meta.prog[ta:right]> (item.duration or 0).format!
			elif pl
				<.children[$count:{pl.items.length} pt:4]> for item,i in pl.items
					<a.scrim.row .current=(item == data) data-id=item.id href=item.contextualUrl(pl)>
						<span.title.truncate> "{i + 1}. {item.title}"
						<span.meta.prog[ta:right]> (item.duration or 0).format!

	def mount
		render!
		$rows = Array.from getElementsByClassName('row')
		$curr = querySelector('.current')

		if $curr
			let nr = $rows.indexOf($curr)
			let offset = $curr.offsetTop
			scrollTop = offset - 100



tag scrim-queue-section < pane-section
	name = 'queue'

	def render
		return if rendered? and !focin?

		<self>
			<scrim-queue data=data>


tag scrim-queue-menu < app-dialog
	css 1w:60vw max-height:50vh t:1hdh mt:2
	css $cover bg:clear
	css $box o:0 scale:1 y:-20px

	def render
		<self[d:vflex].quickmenu>
			<a$cover @click.prevent=close>
			<$box[d:vflex of:hidden p:0 rd:sm]> <scrim-queue data=data>

tag Branch
	
	css .row
		rd:sm p:1 2 mb:1 bd:1px solid clear
		cursor:default d:hflex ja:center
		bg:gray1-5 @hover:gray2 .current:yellow2
		c:gray7 .current:yellow8
		# bc:gray3 @hover:gray4 .current:yellow3
		fs:sm/1.2
		.stat fs:xs o:0.5
		.tools o:0 pe:none pl:1
		&.current bg:yellow2-2 @hover:yellow2-7
			.tools o:1 pe:auto

		&.local
			.title @before content: "Unsaved " fw:600

	get branch
		data.branch
	
	def discard
		let ok = window.confirm("Are you sure you want to delete this scrim?")
		if ok
			await branch.discard!

	def save
		await branch.persist!

	def render
		let curr = branch..isActive!
		<self>
			<.row .local=data.local? .current=curr @click.emit-open(data)>
				<.title[fl:1].truncate> data.title
				<.stat.dim> data.created_at.toTime!
				<.tools[d:hflex]>
					<.tool[w:4 h:4].red @click.stop.prevent=discard> <svg src="svg/trash-2.svg" >
					if data.local?
						<.tool[w:4 h:4].green @click.stop.prevent=save> <svg src="svg/check.svg" >
					

tag scrim-notes-section < pane-section
	name = 'notes'

	<self[p:6 pt:4 ofy:auto]>
		<div[fs:sm c:gray6 mb:2]> "Whenever you start playing around with the code, a Note will be created. All your notes are listed below. To save a Note, click the green checkmark icon."
		<div.notes> for item in data.children
			<Branch data=item>


tag Thread
	level = 0
	get author do data.user

	<self[d:block] data-parent=data.parent_id>
		<div[d:grid gtc:18px 1fr g:8px py:2 mx:4]>
			<div> <img[w:100% rd:100 bxs:xs] src=author.avatar-url!>
			<div>
				<div[fs:xs]>
					<span[fw:600]> author.displayName
					<span[c:gray6 ml:2 fw:500]>
						if $web$
							data.ts.toTimeAgo!
						else
							data.ts.toString!
				<div.md md=data.body>
		<.replies[pl:4]> for item in data.replies
			<Thread data=item level=level+1>

tag scrim-comments-section < pane-section
	name = 'comments'

	<self>
		# <div> "Comments here"
		<div.body[py:3 fl:1 ofy:auto]>
			<div[p:6 pt:1 fs:sm/1.3 c:gray6].md md="Comments are temporarily disabled. In the meantime join our discussions on <a.small href='https://scrimba.com/discord' target='discord'>Discord</a>">
			<.threads> for item in data.messages when !item.parent
				<Thread data=item level=0>
		# <.alert.yellow md="Comments are temporarily disabled. In the meantime join our discussions on [Discord](https://scrimba.com/discord)">
			

tag scrim-about-section < pane-section
	name = 'about'

	get teacher do data.user
	get scrim do data
	get course do store.course

	get avatar
		teacher.avatar-url ? teacher.avatar-url! : undefined
	<self[p:6 pt:4 ofy:auto]>
		<div.main[d:none]>
			<.title[fs:lg fw:500 ta:center mt]> scrim.title
			<.stats[j:center]>
				<.stat> "by {<a.link href=teacher.url> teacher.name}"
				if course
					<.stat> <a.link href=course.url> course.title
		# <hr[w:10 mx:auto h:1px bd:none bg:gray4 my:3]>
		<div.user[mb:4 pb:2 bdb:1px solid gray3]>
			<div[d:hflex mb:2].head>
				<img[bg:gray3 rd:100 w:20 mr:2].avatar src=avatar>
				<div[fl:1]>
					<a.name[fw:600 c:blue7 fs:md/1.2 td:none] href=teacher.url> teacher.name
					<.stats>
						if let gh = (teacher.github_handle or teacher.username)
							<.stat> <a.link.small target='blank' href="https://github.com/{gh}"> "github"
						if let th = teacher.twitter_handle
							<.stat> <a.link.small target='blank' href="https://twitter.com/{th}"> "twitter"
						if let mh = teacher.medium_handle
							<.stat> <a.link.small target='blank' href="https://medium.com/@{mh}"> "medium"
			<div.bio[fs:sm c:gray7 d:none]> teacher.bio
		<.description[fs:md mb:4]>
			if data.description
				<div.md md=data.description>
				# <app-text data=data.markdown>
			else
				<div[c:gray5]> "This Scrim has no description."
		
		


tag scrim-info

	css d:vflex a:stretch

	css .tool
		all:unset d:flex ja:center
		w:6 h:6 rd:sm
		c:gray6 @hover:blue5 # .checked:blue6
		svg w:4 h:4 va:top

	css .cover
		d:none @peek-drawer:hflex ja:center pos:absolute inset:0 rd:inherit
		bg: linear-gradient(white/60,white) 
		mt:-26px fs:md- cursor:default rdb:lg pt:26px
		c:blue6
		td@hover:underline

	css .head
		.tool m:1.5

	css .info
		ja:center d:hflex min-height:10 mb:-2
		

	css .tabs-only d:hflex
		.tool m:2
		.info d:none
		.tabs h:10 bdb:none mx:0 as:stretch fs:xs fw:600
		.tab mx:0 px:1.5 mx:0.5 rd:sm bd:none mb:0 mt:0
			bg:clear .checked:blue1-3

	get teacher do data.user
	get course do store.course

	def render force 
		# return if rendered? and !focin?
		<self tabIndex=-1 @focusout.stop=autohide>
			<.head[d:block fl:0 rdt:inherit bg:white ja:center d:vflex min-height:10].tabs-only>
				<.info>
					<.title[fs:lg/1.1 fw:500 ta:center c:$night py:2 px:8]> data.title
					<.stats[j:center d:none]>
						<.stat> "by {<a.link href=teacher.url> teacher.name}"
						if course
							<.stat> <a.link href=course.url> course.title
				<.tabs>
					<app-tab.tab bind=settings.scrimInfoPane name='about'> "About"
					<app-tab.tab bind=settings.scrimInfoPane name='comments'> "Comments"
					# <app-tab.tab bind=settings.scrimInfoPane name='queue'> "Queue"
					<app-tab.tab bind=settings.scrimInfoPane name='notes'> "Notes"

				<app-toggler.tool[pos:absolute l:0 t:0 rotate:45deg .checked:225deg] bind=lmods['pin-drawer']> <svg src="svg/chevrons-left.svg" >
				<app-toggler.tool[pos:absolute r:0 t:0] bind=lmods['show-drawer']> <svg src="svg/x.svg" >

			<.sections[fl:1 pos:relative]>	
				<scrim-about-section data=data>
				<scrim-notes-section data=data>
				<scrim-comments-section data=data>
				# <scrim-queue-section data=data>
				# <.cover @click=show> <div> "Expand for more info"
			if let item = data.next
				if !item.released_at or (item.released_at < Date.now())
					<scrim-next-up data=item course=data.course>
			

	def autohide
		return		
		setTimeout(&,100) do
			if !lmods['pin-drawer'] and !focin?
				flags.remove('autoshow')
				console.log 'hiding',document.activeElement
				lmods['show-drawer'] = false
		self
	
	get shown?
		lmods['show-drawer']

	def show
		api.flags.remove('mod-peek-drawer')
		lmods['show-drawer'] = yes

	def mount
		focus! if window.parent == window
		schedule!

	def unmount
		unschedule!

	def queueNext
		querySelector('scrim-next-up').queueNext!
	
	def cancelNext
		querySelector('scrim-next-up').cancelQueue!

tag scrim-peek-info
	get teacher do data.user
	get course do store.course

	# css scrim-next-up
	#	.!queued visibility:hidden

	def expand
		api.flags.remove('mod-peek-drawer')
		lmods['show-drawer'] = yes
	
	def show dur = 0
		api.flags.add('mod-peek-drawer')
		clearTimeout($hide)
		if dur
			$hide = setTimeout(&,dur) do hide!
		self

	def hide
		api.flags.remove('mod-peek-drawer')

	def queueNext
		show!
		$next.queueNext!

	def render
		<self[cursor:default bg:white/95 @hover:white]>
			<div[d:vflex ja:center p:4] @click=expand>
				<.title[fs:lg/1.1 fw:500 ta:center c:$night]> data.title
				<.stats[j:center d:none]>
					<.stat> "by {<a.link href=teacher.url> teacher.name}"
					if course
						<.stat> <a.link href=course.url> course.title
				<div[c:blue6 fs:sm]> "Expand for more info"
			if data.next
				<scrim-next-up$next data=data.next course=course @cancel=hide>